{
  const website = document.getElementById('website');
  const facebook = document.getElementById('facebook');

  if(website && facebook){
    function toggleRequired() {
      facebook.required = website.value.trim() == "";
      website.required = facebook.value.trim() == "";
    }
    website.addEventListener('input', toggleRequired);
    facebook.addEventListener('input', toggleRequired);
  }
}